import * as yup from 'yup';
import { BrewerStatusType } from '../types';

export const createUpdateBrewerDialogSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
  amsAgreement: yup.bool().required().label('AMS Agreement'),
  userId: yup
    .string()
    .optional()
    .transform((value, originalValue) =>
      originalValue === null || originalValue === '' ? undefined : value === '' ? undefined : value
    )
    .label('User'),
  status: yup.mixed<BrewerStatusType>().oneOf(Object.values(BrewerStatusType)).required().label('Status'),
  maxFixes: yup
    .number()
    .label('Max Fixes')
    .transform((value, originalValue) =>
      originalValue === null || originalValue === '' ? undefined : value === '' ? undefined : value
    )
    .label('Max fixes')
    .when('amsAgreement', ([amsAgreement], schema) => {
      return amsAgreement === true ? schema.required('Max Fixes are required') : schema.optional();
    })
});
